"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.selectStartPlaybackAttempt = exports.selectPlayerIsStalled = exports.selectPlayerInLoadingState = exports.selectLastRequiredPlayState = exports.selectPlaylistIsUpdating = exports.selectPlayerVolume = exports.selectPositionReportingEnabled = exports.selectNextTrackWillStart = exports.selectRequiredPlayState = exports.selectCurrentPlayState = void 0;
var moment_timezone_1 = __importDefault(require("moment-timezone"));
var _kernel_store_types_1 = require("../types");
function selectCurrentPlayState(state) {
    return state.player.currentPlayState;
}
exports.selectCurrentPlayState = selectCurrentPlayState;
function selectRequiredPlayState(state) {
    return state.player.requiredPlayState;
}
exports.selectRequiredPlayState = selectRequiredPlayState;
function selectNextTrackWillStart(state) {
    var nextTime = state.player.currentPlayState === _kernel_store_types_1.EPlayState.PLAY
        ? state.player.nextTrackWillStartAt
        : Date.now();
    return (0, moment_timezone_1.default)(nextTime !== null && nextTime !== void 0 ? nextTime : Date.now());
}
exports.selectNextTrackWillStart = selectNextTrackWillStart;
function selectPositionReportingEnabled(state) {
    return false;
}
exports.selectPositionReportingEnabled = selectPositionReportingEnabled;
function selectPlayerVolume(state) {
    return state.player.volume;
}
exports.selectPlayerVolume = selectPlayerVolume;
function selectPlaylistIsUpdating(state) {
    var _a;
    return (_a = state.player.playlistIsUpdating) !== null && _a !== void 0 ? _a : false;
}
exports.selectPlaylistIsUpdating = selectPlaylistIsUpdating;
function selectLastRequiredPlayState(state) {
    return state.player.lastRequiredPlayState;
}
exports.selectLastRequiredPlayState = selectLastRequiredPlayState;
function selectPlayerInLoadingState(state) {
    return state.player.playerLoading;
}
exports.selectPlayerInLoadingState = selectPlayerInLoadingState;
function selectPlayerIsStalled(state) {
    return state.player.playerStalled;
}
exports.selectPlayerIsStalled = selectPlayerIsStalled;
function selectStartPlaybackAttempt(state) {
    return state.player.startPlaybackAttempt;
}
exports.selectStartPlaybackAttempt = selectStartPlaybackAttempt;
//# sourceMappingURL=player.js.map